<template>
  <div class="row">
    <div class="col-20 std-wrapper images-wrapper">
      <div class="row">
        <div class="col-20 bg-col">
          <div
            class="background-image-img"
            :style="'background-image: url(' + $store.getters['user/getBackground'](userData) + ')'"
          />

          <div
            class="avatar-image-img"
            :style="`background-image: url(${$store.getters['user/getAvatar'](userData)})`"
          />
        </div>
      </div>
      <div class="row">
        <div :class="`col-20 col-lg-14 offset-lg-5 pt-2 basic-info-${userData.type}`">
          <div
            v-if="userData.type === 'advertiser'"
            class="row"
          >
            <div class="col-20 col-sm-14 mt-1">
              <div class="d-inline-block name-block-wrapper">
                <div>
                  <h2 class="user-fullname">
                    {{ userData.name }}
                  </h2>
                  <span v-if="!onlyInfo">
                    <span
                      v-if="typeData.verified"
                      class="verified text-success"
                    >
                      {{ $t('view-UserProfile.verification.verified') }}
                    </span>
                    <span
                      v-else
                      class="not-verified text-danger"
                    >
                      {{ $t('view-UserProfile.verification.not-verified') }}
                    </span>
                  </span>
                </div>
                <div class="w-100 channels-icons">
                  <a
                    v-if="typeData.facebook"
                    class="advertiser-social"
                    :style="`background-image: url(${$publicPath}img/social/color/facebook.svg)`"
                    :href="typeData.facebook"
                    target="_blank"
                  >
                    facebook
                  </a>
                  <a
                    v-if="typeData.instagram"
                    class="advertiser-social"
                    :style="`background-image: url(${$publicPath}img/social/color/instagram.svg)`"
                    :href="typeData.instagram"
                    target="_blank"
                  >
                    instagram
                  </a>
                  <a
                    v-if="typeData.linkedin"
                    class="advertiser-social"
                    :style="`background-image: url(${$publicPath}img/social/color/linkedin.svg)`"
                    :href="typeData.linkedin"
                    target="_blank"
                  >
                    linkedin
                  </a>
                </div>
              </div>
            </div>
            <div class="col-20 col-sm-6 pt-4">
              <std-button
                v-if="userData.id === $store.state.user.profile.id && !onlyInfo"
                :route-link="{name: 'profile-personal-data-edit'}"
                add-class=""
                type="C"
                :title="$t('view-UserProfile.button.profile-edit')"
              />
              <slot name="buttons" />
            </div>
          </div>
          <div
            v-else
            class="row"
          >
            <div class="col-20 col-sm-9 mt-1">
              <div class="d-inline-block name-block-wrapper">
                <div>
                  <h2 class="user-fullname">
                    {{ typeData.first_name }} {{ typeData.last_name }}
                  </h2>
                  <span class="nick">@{{ userData.name }}</span>
                </div>
              </div>
              <div class="w-100 channels-icons">
                <img
                  v-for="ch in channelsIcons"
                  :key="ch.name"
                  :src="ch.icon"
                >
              </div>
            </div>
            <div class="col-20 col-sm-5 pt-3">
              <div class="d-flex align-items-center">
                <div
                  v-if="countryFlag"
                  class="flag mr-2"
                  :style="`background-image: url(${countryFlag})`"
                />
                <div
                  v-if="archetype"
                  class="text-center archetype"
                >
                  <img
                    :src="archetype.icon"
                    :alt="archetype.name"
                  >
                  <br>{{ archetype.name }}
                </div>
              </div>
            </div>
            <div class="col-20 col-sm-6 pt-2">
              <total-nativestars
                :total="typeData.nativestars"
                :small="true"
                class="my-3"
              />
              <std-button
                v-if="userData.id === $store.state.user.profile.id"
                :route-link="{name: 'profile-personal-data-edit'}"
                add-class=""
                type="C"
                :title="$t('view-UserProfile.button.profile-edit')"
              />
              <add-to-favlist-button
                v-if="typeData && showAddRemoveFavlistButton"
                :influencer-id="typeData.id"
                class="d-none d-sm-block w-100"
              />
              <remove-from-favlist-button
                v-if="typeData && showAddRemoveFavlistButton"
                :influencer-id="typeData.id"
                class="d-none d-sm-block w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Total from '../nativestars-partials/Total'
import AddToFavlistButton from '../../influencer-list/AddToFavlistButton'
import RemoveFromFavlistButton from '../../influencer-list/RemoveFromFavlistButton'

export default {
  components: {
    'total-nativestars': Total,
    'add-to-favlist-button': AddToFavlistButton,
    'remove-from-favlist-button': RemoveFromFavlistButton
  },
  props: {
    userData: {
      type: Object,
      default: () => { return {} }
    },
    typeData: {
      type: Object,
      default: () => { return {} }
    },
    channels: {
      type: Array,
      default: () => []
    },
    onlyInfo: {
      type: Boolean,
      default: false
    },
    showAddRemoveFavlistButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {

    }
  },
  computed: {
    countryFlag () {
      if (!this.typeData.country) {
        return null
      }
      return `//raw.githubusercontent.com/google/region-flags/gh-pages/svg/${this.typeData.country}.svg`
    },
    archetype () {
      const archetypes = this.typeData.userArchetypes

      if (archetypes && archetypes.length > 0) {
        return {
          name: this.$store.getters['archetypes/getName'](archetypes[0].archetype_id),
          icon: `${this.$publicPath}img/archetypes/${archetypes[0].archetypeData.tag}.svg`
        }
      } else {
        return null
      }
    },
    channelsIcons () {
      const result = []
      for (const type of this.$store.state.channelsTypes.items) {
        const hasChannel = this.channels.filter(ch => ch.type_name === type.name).length > 0
        result.push({
          name: type.name,
          icon: hasChannel ? `${this.$publicPath}img/social/color/${type.name}.svg` : `${this.$publicPath}img/social/gray/${type.name}.svg`
        })
      }
      return result
    }
  },
  created () {
    if (this.$store.state.archetypes.items.length === 0) {
      this.$store.dispatch('archetypes/get')
    }
    if (this.$store.state.channelsTypes.items.length === 0) {
      this.$store.dispatch('channelsTypes/get')
    }
  }
}
</script>

<style lang="scss" scoped>
  .images-wrapper {
    overflow: hidden;
    .bg-col {
      padding: 0;
      margin-top: -10px;
    }
  }

  .background-image-img {
    width: 100%;
    height: 232px;
  }

  .avatar-image-img {
    position: absolute;
    top: 56%;
    left: 14%;
    transform: translateX(-50%);
    border: 7px solid white;
    border-radius: 100%;
    width: 200px;
    height: 200px;
    @include media-breakpoint-down(md) {
      top: 7%;
      left: 50%;
    }
  }

  .basic-info-influencer {
    min-height: 160px;
  }

  .basic-info-advertiser {
    min-height: 110px;
  }

  ::v-deep {
    .nh-btn-type-C {
      min-width: 100%;
      padding: 0.7rem 0.75rem;
      padding-bottom: 0.5rem;
    }
  }

  .channels-icons {
    margin-top: 2rem;
    img {
      width: 20px;
      margin-right: 0.42rem;
    }
  }

  .flag {
    margin-top: -0.5rem;
    width: 29px;
    height: 29px;
    border-radius: 100%;
    box-shadow: 5px 0px 10px rgba(0, 0, 0, 0.08);
    background-repeat: no-repeat;
    background-size: cover;
  }
  .archetype {
    padding-left: 0.5rem;
    img {
      max-height: 40px;
    }
    font-size: 0.5rem;
  }

  .advertiser-social {
    display: inline-block;
    border: 2px solid $nh-gray;
    border-radius: 5px;
    padding: 0.25rem 0.5rem;
    padding-left: 2rem;
    font-size: 0.75rem;
    background-repeat: no-repeat;
    background-position: 5px center;
    background-size: 20px;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    transition: 0.2s;
    &:hover {
      border-color: $warning;
      text-decoration: none;
      color: black;
    }
  }
</style>
